import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';

import { useTokenContext } from '../../token.context';

export const StateCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const token = useTokenContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card gap={GapEnum.M} flex={1}>
      <Stack justifyContent="space-between" gap={GapEnum.S} alignItems="center">
        <AccentTitle
          icon="credit-card-01"
          as={HeadingEnum.H2}
          text={t('$.token-details.state.title')}
          variant={AccentVariantEnum.Accent1}
        />
        {token.valid ? (
          <Tag className="bg-surface-success">
            <Stack
              flex={1}
              justifyContent="space-between"
              gap={GapEnum.S}
              alignItems="center">
              <Icon name="check-circle" />
              <Text bold>{t('$.token-list.valid.true')}</Text>
            </Stack>
          </Tag>
        ) : (
          <Tag className="bg-surface-error">
            {t('$.token-list.valid.false')}
          </Tag>
        )}
      </Stack>
      {token.updatedAt && (
        <Stack gap={GapEnum.S} alignItems="center">
          <Text bold>
            {t('delmonicos-shared-sdk.outputs-base-with-timestamp.updated-at')}
          </Text>
          <Text>{formatDate(token.updatedAt, i18n)}</Text>
        </Stack>
      )}
    </Card>
  );
};
